import { createSlice } from "@reduxjs/toolkit";

export const CheckChargebeeSubscriptionSlice = createSlice({
  name: "CheckChargebeeSubscription",
  initialState: {
    CheckChargebeeSubscription: false,
    subscrption_renew_status: false,
    subscriptionRenewMessage: '', // changed from renew_message
  },
  reducers: {
    getCheckChargebeeSubscription: (state, action) => {
      state.CheckChargebeeSubscription = action.payload;
    },
    setSubscriptionRenewStatus: (state, action) => {
      state.subscrption_renew_status = action.payload;
    },
    setSubscriptionRenewMessage: (state, action) => {
      state.subscriptionRenewMessage = action.payload; // now matches state
    }
  },
});

export const { getCheckChargebeeSubscription, setSubscriptionRenewStatus, setSubscriptionRenewMessage } =
  CheckChargebeeSubscriptionSlice.actions;

export default CheckChargebeeSubscriptionSlice.reducer;
